import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { RouterLinkStyled, LinkStyled, StyledIcon } from './styles/LinkStyled';

const Link = ({
  to,
  href,
  children,
  iconName,
  iconColor,
  title,
  target,
  type,
  background,
  iconSize,
  iconHeight,
  iconWidth,
  transform,
  textColor,
  hoverColor,
  textSize,
  className,
}) => {
  if (to) {
    return (
      <RouterLinkStyled
        className={className}
        transform={transform}
        to={to}
        type={type}
        title={title}
        icon={iconName}
        color={textColor}
        hover={hoverColor}
        size={textSize}
      >
        {iconName && (
          <StyledIcon name={iconName} color={iconColor} size={iconSize} />
        )}
        {children}
      </RouterLinkStyled>
    );
  } else if (type === 'social') {
    return (
      <LinkStyled
        className={className}
        type={type}
        href={href}
        icon={iconName}
        title={title}
        target={target}
        transform={transform}
        color={textColor}
        hover={hoverColor}
        size={textSize}
        style={{
          backgroundColor: background,
        }}
      >
        {iconName && (
          <StyledIcon name={iconName} color={iconColor} size={iconSize} />
        )}
        {children}
      </LinkStyled>
    );
  } else if (type === 'logo') {
    return (
      <LinkStyled
        className={className}
        type={type}
        href={href}
        icon={iconName}
        title={title}
        target={target}
        transform={transform}
        color={textColor}
        hover={hoverColor}
        size={textSize}
        style={{
          backgroundColor: background,
        }}
      >
        {iconName && (
          <StyledIcon
            name={iconName}
            color={iconColor}
            width={iconWidth}
            height={iconHeight}
            viewBox="none"
          />
        )}
        {children}
      </LinkStyled>
    );
  }
  return (
    <LinkStyled
      className={className}
      type={type}
      href={href}
      icon={iconName}
      title={title}
      target={target}
      color={textColor}
      hover={hoverColor}
      size={textSize}
      transform={transform}
      style={{
        backgroundColor: background,
      }}
    >
      {iconName && (
        <StyledIcon name={iconName} color={iconColor} size={iconSize} />
      )}
      {children}
    </LinkStyled>
  );
};

Link.propTypes = {
  to: PropTypes.string,
  href: PropTypes.string,
  iconName: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({ id: PropTypes.string }),
  ]),
  iconColor: PropTypes.string,
  title: PropTypes.string,
  target: PropTypes.string,
  children: PropTypes.node,
  type: PropTypes.string,
  background: PropTypes.string,
  iconHeight: PropTypes.number,
  iconWidth: PropTypes.number,
  iconSize: PropTypes.number,
  transform: PropTypes.string,
  textColor: PropTypes.string,
  hoverColor: PropTypes.string,
  textSize: PropTypes.string,
  className: PropTypes.string,
};

Link.defaultProps = {
  to: null,
  href: '',
  iconName: '',
  title: null,
  target: '_blank',
  children: null,
  type: null,
  iconColor: 'white',
  background: '',
  iconHeight: null,
  iconWidth: null,
  iconSize: null,
  transform: null,
  textColor: '',
  hoverColor: '',
  textSize: null,
  className: '',
};

export default memo(Link);
